export default __webpack_public_path__ + "static/media/cream-wave-4.3eff6ea7.svg";